<template>
  <v-icon xsize="medium" color="#1b5e20">
    mdi-delete
  </v-icon>
</template>
